import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import storage from "../../Assets/js/Global";
import { GlobalContext } from "../../Context/GlobalContext";
import { images } from "../../Assets/images";
import { Languages } from "lucide-react";

// Shown once per app session (full reload). Stays false across in-app
// navigation so returning here (e.g. Back from Login) doesn't replay the splash.
let hasShownSplash = false;

const LanguageSelector = () => {
  const {
    setSelected,
    selected,
    setIsManualChange,
    translatedLabels,
    languages,
    getLanguageList,
    logoUrl,
    is4Life,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  let location = useLocation();
  let pathname = location.pathname;
  let isLanguagePage = pathname === "/language-selection";

  const isLoggedIn = storage.get("isLoggedIn");
  const [showSplash, setShowSplash] = useState(!hasShownSplash);

  useEffect(() => {
    storage.set("selectedLanguage", selected);
    setSelected(selected);
  }, [selected, setSelected]);
  useEffect(() => {
    hasShownSplash = true;
    const timer = setTimeout(() => setShowSplash(false), 3000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    getLanguageList();
  }, [getLanguageList]);

  const companyId = process.env.REACT_APP_COMPANY_ID;
  if (showSplash && !isLoggedIn && companyId === "8nn29") {
    return (
      <div className="splash-screen">
        <div className="splash-overlay"></div>
        <img src={images.initialLogo} alt="App Logo" className="splash-logo" />
      </div>
    );
  }
  return (
    <div className="container">
      <div className="header-container pt-5">
        <div className="d-flex justify-content-center">
          {!isLoggedIn && (
            <div
              className="app-logo"
              style={is4Life ? { height: "80px", width: "200px" } : {}}
            >
              <img
                src={
                  logoUrl ||
                  (companyId === "wu9zm8"
                    ? images.brasilLogo
                    : companyId === "8nn29"
                      ? images.globalHealthLogo
                      : images.appLogo)
                }
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  if (companyId === "wu9zm8") e.target.src = images.brasilLogo;
                  else if (companyId === "8nn29")
                    e.target.src = images.globalHealthLogo;
                  else e.target.src = images.appLogo;
                }}
              />
            </div>
          )}
        </div>

        <h4 className="fw-semibold mt-4 mb-4 d-flex align-items-center gap-2">
          <Languages color="#11A8DF" size={30} />
          <span className="mb-0 fw-semibold">
            {authLabel?.choose_your_language?.label_value ||
              "Choose your language"}
          </span>
        </h4>
      </div>

      <div className="mb-4">
        {languages?.map((lang, index) => (
          <div
            key={index}
            className={`card language-card shadow-sm ${
              selected === lang.language_code ? "border-primary bg-light" : ""
            }`}
            onClick={() => {
              setSelected(lang.language_code);
              setIsManualChange(true);
            }}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <p className="language-name">{lang.language_translate}</p>
                <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                  {lang.language_name}
                </p>
              </div>
              {selected === lang.language_code && (
                <img src={images.checkIcon} alt="check-icon" />
              )}
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <div
          className={`continue-btn  ${!isLanguagePage ? "bottom-padding pt-5" : "pt-5"}`}
        >
          <Link
            to={isLoggedIn ? "/profile" : "/login"}
            className="btn btn-primary"
          >
            {authLabel?.continue?.label_value || "Continue"}
          </Link>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
